// extracted by mini-css-extract-plugin
export default {"imageWrapper":"MJ-z","twoColumnImage":"NJ-z"};